import React, { useEffect, useState } from "react";
import reactDom from "react-dom";
import { useTranslation } from "react-i18next";

import {
  ModalRoot,
  Backdrop,
  ModalContainer,
  ModalWrap,
  ModalHeader,
  ModalBody,
  ButtonGroup,
  PrimaryButton,
} from "./SessionExpiryModal.styles";

import { getLocalStorage, removeLocalStorage } from "../../shared/utils/localStorage";

import storageConstants from "../../shared/constants/storage";

const { SESSION_EXPIRED } = storageConstants;

/**
 * Session Expiry Modal Component
 *
 * @param {string} size - Size of the modal ('sm' supported)
 */
export const SessionExpiryModal = ({ size = "sm" }) => {
  const { t: translate } = useTranslation();

  const [showSessionExpiryModal, setShowSessionExpiryModal] = useState(!!getLocalStorage(SESSION_EXPIRED));

  useEffect(() => {
    if (!showSessionExpiryModal) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = prev;
    };
  }, [showSessionExpiryModal]);

  if (!showSessionExpiryModal) return null;
  return reactDom.createPortal(
    <ModalRoot role="dialog" aria-modal="true">
      <Backdrop />
      <ModalContainer>
        <ModalWrap size={size}>
          <ModalHeader>
            <h2>{translate("error")}</h2>
          </ModalHeader>
          <ModalBody className="modal-body">{translate("session_expired")}</ModalBody>
          <ButtonGroup>
            <PrimaryButton
              onClick={() => {
                removeLocalStorage(SESSION_EXPIRED);
                setShowSessionExpiryModal(false);
              }}
            >
              {translate("ok")}
            </PrimaryButton>
          </ButtonGroup>
        </ModalWrap>
      </ModalContainer>
    </ModalRoot>,
    document.body
  );
};
